import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Compass, ArrowRight } from "@phosphor-icons/react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/app");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2">
      <div className="hidden md:flex flex-col justify-between p-10 bg-foreground text-background">
        <Link to="/" className="flex items-center gap-2" data-testid="login-brand">
          <div className="w-7 h-7 bg-primary text-primary-foreground flex items-center justify-center"><Compass size={16} weight="bold" /></div>
          <span className="font-display text-xl">DKK Info Tech</span>
        </Link>
        <div>
          <div className="overline text-accent mb-4">Welcome back</div>
          <h2 className="font-display text-5xl leading-none tracking-tighter">Continue your governance journey.</h2>
          <p className="text-white/60 mt-6 max-w-md">Your progress, quiz scores and tutor conversations are waiting.</p>
        </div>
        <div className="text-xs font-mono uppercase tracking-widest text-white/40">Secure · Encrypted · GDPR-aware</div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="login-form">
          <div>
            <div className="overline mb-2">Sign in</div>
            <h1 className="font-display text-4xl tracking-tighter">Log in to your account</h1>
          </div>
          <label className="block">
            <div className="text-xs font-medium uppercase tracking-widest mb-1">Email</div>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-border px-3 py-2 focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary"
              data-testid="login-email" />
          </label>
          <label className="block">
            <div className="text-xs font-medium uppercase tracking-widest mb-1">Password</div>
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-border px-3 py-2 focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary"
              data-testid="login-password" />
          </label>
          <button disabled={busy} type="submit"
            className="w-full py-3 bg-primary text-primary-foreground text-sm font-medium flex items-center justify-center gap-2 disabled:opacity-60 hover:bg-[color:hsl(223_100%_28%)] transition-colors"
            data-testid="login-submit">
            {busy ? "Signing in…" : (<>Sign in <ArrowRight size={14} weight="bold" /></>)}
          </button>
          <div className="text-sm text-muted-foreground">
            No account?{" "}
            <Link to="/register" className="text-primary font-medium underline underline-offset-4" data-testid="login-to-register">Create one</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
